<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    pulse: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<'md' | 'lg'>,
      default: 'md',
    },
    link: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      required: false,
    },
    target: {
      type: String as PropType<'_blank'>,
      required: false,
    },
  },
  emits: ['click'],
})
</script>

<template>
  <button
    v-if="!link"
    class="text-darkblue active:bg-blue relative flex h-10 cursor-pointer items-center justify-center p-4 text-center active:text-white"
    :class="{ 'error-pulse': pulse, 'hover:bg-blue hover:text-white': !pulse }"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
  <a
    v-else
    class="text-darkblue active:bg-blue relative flex h-10 cursor-pointer items-center justify-center p-4 text-center active:text-white"
    :class="{ 'error-pulse': pulse, 'hover:bg-blue hover:text-white': !pulse }"
    :href="to"
    :target
    @click="$emit('click')"
  >
    <slot></slot>
  </a>
</template>

<style scoped>
@config "@mobile/../tailwind.config.js";

.error-pulse {
  animation: error-pulse-animation 3s infinite;
}

@keyframes error-pulse-animation {
  0% {
    background-color: transparent;
    color: theme('colors.darkblue');
  }
  50% {
    background-color: theme('colors.error');
    color: theme('colors.white');
  }
  100% {
    background-color: transparent;
    color: theme('colors.darkblue');
  }
}
</style>
